import { render, staticRenderFns } from "./productHeat.vue?vue&type=template&id=b824cfe4&scoped=true&"
import script from "./productHeat.vue?vue&type=script&lang=js&"
export * from "./productHeat.vue?vue&type=script&lang=js&"
import style0 from "./productHeat.vue?vue&type=style&index=0&id=b824cfe4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b824cfe4",
  null
  
)

export default component.exports